module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56402c54","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/PageContent.vue
// module id = 1125
// module chunks = 1